import React from "react";

import { Container, Row } from "react-bootstrap";

import IconWorkout from "../../common/images/iconWorkout.png";
import IconWorkoutActive from "../../common/images/iconWorkoutActive.png";
import IconProfile from "../../common/images/iconProfile.png";
import IconProfileActive from "../../common/images/iconProfileActive.png";
import IconSkills from "../../common/images/iconSkills.png";
import IconSkillsActive from "../../common/images/iconSkillsActive.png";
import IconExercises from "../../common/images/iconExercises.png";
import IconExercisesActive from "../../common/images/iconExercisesActive.png";
import CustomIconTab from "../../common/components/CustomIconTab";
import {
  isiOS,
  isRunningStandalone,
} from "../../common/components/NavbarResponsive";

export default function AccountBottomNavBar() {
  const paddingBottom = isiOS() && isRunningStandalone() ? "1.5rem" : "0.5rem";

  return (
    <>
      <div
        onContextMenu={(e) => e.preventDefault()}
        className="align-self-center text-center account-bottom-navbar"
        style={{ paddingBottom: paddingBottom }}
      >
        <Container
          className="blur m-auto shadow-sm rounded-pill py-1"
          style={{
            background: "#ffffffc9",
            width: "96%",
            border: "1px solid #eeeded"
          }}
        >
          <Row>
            <CustomIconTab
              key={1}
              to={"/account/Profile"}
              text={"Profilo"}
              width={32}
              image={IconSkills}
              imageHovered={IconSkillsActive}
              imageActive={IconSkillsActive}
            />
            <CustomIconTab
              key={2}
              to={"/account/Workouts"}
              text={"Allenamenti"}
              width={32}
              image={IconWorkout}
              imageHovered={IconWorkoutActive}
              imageActive={IconWorkoutActive}
            />
            <CustomIconTab
              key={3}
              to={"/account/Exercises"}
              text={"Esercizi"}
              width={32}
              image={IconExercises}
              imageHovered={IconExercisesActive}
              imageActive={IconExercisesActive}
            />
            <CustomIconTab
              key={4}
              to={"/account/Account"}
              text={"Account"}
              width={32}
              image={IconProfile}
              imageHovered={IconProfileActive}
              imageActive={IconProfileActive}
            />
          </Row>
        </Container>
      </div>
    </>
  );
}
